export default function People() {
    return (
        <div className='document'>
            <h3>People</h3>
            <h4>Current Contributors:</h4>
            <article>
                <div>
                    <br clear='left' />
                    <strong>Adrien Zakar</strong> is Assistant Professor at the
                    University of Toronto's Department of Near and Middle
                    Eastern Civilizations and the Institute for the History and
                    Philosophy of Science and Technology. Previously, he
                    received a Ph.D. in History from Columbia University in 2018
                    and then worked as a Mellon Postdoctoral Scholar at the
                    Stanford Humanities Center and a lecturer in the Department
                    of History at the same institution. Adrien is a historian of
                    science and technology with expertise in maps, visual
                    practices, and spatial history. Using a new range of
                    archival sources in Ottoman, Turkish, Arabic, and French,
                    his work joins historical research with an interdisciplinary
                    approach to science and technology studies, critical
                    geography, and war studies. Outside his individual research,
                    Adrien enjoys collaborating with creative professionals and
                    student engineers towards generating cutting-edge
                    visualizations and processes that engage with the past as
                    much as contemporary questions and concerns such as the
                    attention economy and global shipping routes. For more
                    information, visit:{" "}
                    <a href='https://www.adrienzakar.com/'>adrienzakar.com</a>
                    <img
                        src='https://geocistern.github.io/images/Adrien%20Zakar_2018_01.jpg'
                        alt='AdrienZakar'
                        width='245'
                        height='350'
                        align='left'
                    ></img>
                    <br clear='left' />
                </div>
            </article>
            <article>
                <div className='grid'>
                    <img
                        src='https://geocistern.github.io/images/merve.jpg'
                        alt='MerveTekgurler'
                        width='342'
                        height='256'
                    ></img>
                    <div>
                        <strong>Merve Tekgürler</strong> is the co-founder of
                        Cistern and a PhD student in History at Stanford
                        University. They have a BA degree in History and Social
                        and Cultural Anthropology from Freie University, Berlin.
                        In their dissertation research, Merve is working on
                        Ottoman-Polish borderlands in late eighteenth and early
                        nineteenth centuries, with a focus on changes and
                        continuities north of the Danubian River in relation to
                        Russian and Austrian imperial policy. Merve’s interest
                        in spatial analysis and digital humanities is related to
                        understanding human geography as an integral part of
                        history. Aside from the Cistern project, Merve is
                        working on training a handwritten text recognition model
                        for eighteenth century Ottoman Turkish and is
                        contributing to Mapping Ottoman Epirus project. Outside
                        the academia, Merve enjoys scuba diving, playing Animal
                        Crossing, and traveling.
                    </div>
                </div>
            </article>
            <article>
                <img
                    src='https://geocistern.github.io/images/umar.jpeg'
                    alt='UmarPatel'
                    width='245'
                    height='350'
                    // style='width:245px;height:350px;'
                ></img>
                <br />
                <strong>Umar Patel</strong> is a second year undergraduate
                student double majoring in Computer Science and Archaeology and
                minoring in Mechanical Engineering. Umar holds widespread
                passions in technical and engineering fields, and enjoys
                pursuing them via his interests in late Ancient and Medieval
                European contexts. His projects revolve around the cross-section
                of computer science and archaeology, notably including
                conducting an engineering analysis of the construction of
                Stonehenge and developing virtual models for late Roman
                shipwrecks to use mathematical and computational analysis in
                determining stacking methods for Roman cargoes in the
                Mediterranean. Umar’s other technical pursuits include Machine
                Learning (particularly Natural Language Processing and Computer
                Vision) and Virtual Reality, both of which he is using to help
                develop Cistern’s geographical works database and a virtual
                museum to display early modern Ottoman heritage. When he is not
                working on digital humanities, Umar’s main focus is on
                developing novel machine learning applications such as chatbots,
                information retrieval programs, and recommender systems, or on
                developing virtual worlds with Unity 3D software. In his free
                time, Umar loves to tinker with Arduinos and Raspberry Pis as
                well as read about Medieval British history dating back to the
                Anglo-Saxons.
            </article>
            <article>
                <img
                    src='https://geocistern.github.io/images/isin.jpg'
                    alt='IsinTaylan'
                    width='250'
                    height='250'
                    // style='width:245px;height:350px;'
                ></img>
                <br />
                <strong>Isin Taylan</strong> is a Ph.D. candidate in the
                Department of History at Yale University. She studied Social and
                Political Sciences with a minor in Art Theory and Criticism at
                Sabancı University and Sciences Po Paris. She holds MA degrees
                in History from Central European University and Sabancı
                University. Her dissertation, “The Atlas and the Making of
                Modern Geography in the Ottoman Empire”, examines the making of
                the discipline of geography in the Ottoman Empire through the
                emergence and rise of the genre of the atlas from the
                seventeenth to twentieth century. She has a forthcoming article
                in Imago Mundi: The International Journal for the History of
                Cartography which introduces early Ottoman atlases as a source
                for the history of cartography. She is also a recording team
                member and host at the Ottoman History Podcast.
            </article>
            <article>
                <img
                    src='https://geocistern.github.io/images/jayna.jpg'
                    alt='JaynaHuang'
                    width='197'
                    height='256'
                    // style='width:245px;height:350px;'
                ></img>
                <br />
                <strong>Jayna Huang</strong> is a high school student interested
                in computer science, history, and sociology. She especially
                enjoys perusing the development of early societies, using code
                for practical problem-solving, and exploring Christianity in the
                modern context. With Cistern, Jayna has helped develop a
                database to succinctly organize Ottoman geographical knowledge
                and also has created this website to host it. In her free time,
                Jayna enjoys playing soccer, watching the sunset, and playing
                guitar.
            </article>
            <h4>Past Contributors:</h4>
            <article>
                <img
                    src='https://geocistern.github.io/images/keoni.jpeg'
                    alt='KeoniRodriguez'
                    width='320'
                    height='240'
                    // style='width:245px;height:350px;'
                ></img>
                <br />
                <strong>Keoni Rodriguez</strong> is a BA (History) and MA (Earth
                Systems) candidate at Stanford from San Diego, CA. Their
                scholarship is primarily concerned with Indigenous environmental
                history and identity formation and they worked with the "Mapping
                Geographical Knowledge in the Middle East" project in Winter
                2021.
            </article>
        </div>
    );
}
